import {
  ACCESS_TOKEN_STORAGE_KEY,
  CURRENT_PROJECT_UUID_STORAGE_KEY,
  LANGUAGE_STORAGE_KEY,
  SAML_ORGANIZATION_UUID_STORAGE_KEY,
} from "@frontend-shared/constants";

import { FLAVOR_CONFIG } from "@/lib/flavor-config";

export const getToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
};

export const setToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
};

export const removeToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
};

export const getProjectUuid = (): string | null => {
  return localStorage.getItem(CURRENT_PROJECT_UUID_STORAGE_KEY);
};

export const getLanguage = (): string | null => {
  return (
    localStorage.getItem(LANGUAGE_STORAGE_KEY) || FLAVOR_CONFIG.defaultLanguage
  );
};

export const getSamlOrganizationUuid = (): string | null => {
  return localStorage.getItem(SAML_ORGANIZATION_UUID_STORAGE_KEY);
};
